import { useCoverageBetaStore } from "@/store/useCoverageBetaStore";
import { Button, Tooltip } from "@mantine/core";
import { IconEye, IconEyeOff } from "@tabler/icons-react";

interface Props {
  /** SAM 2 guesses on the frame shown. */
  count: number;
}

/**
 * Admin view: shows or hides SAM 2's guesses over the frames, next to the
 * labelers' boxes. Rendered only for tasks with SAM 2 guesses.
 */
export const Sam2BoxesToggle = ({ count }: Props) => {
  const showSam2Boxes = useCoverageBetaStore((s) => s.showSam2Boxes);
  const toggleSam2Boxes = useCoverageBetaStore((s) => s.toggleSam2Boxes);
  const Icon = showSam2Boxes ? IconEye : IconEyeOff;
  return (
    <Tooltip
      label={
        showSam2Boxes
          ? "Hide SAM 2's guesses"
          : "Show SAM 2's guesses next to the labelers' boxes"
      }
      position="left"
    >
      <Button
        size="compact-xs"
        color="violet"
        variant={showSam2Boxes ? "filled" : "default"}
        aria-pressed={showSam2Boxes}
        // Same-width icons, so the button doesn't resize as it toggles.
        leftSection={<Icon size={14} />}
        onClick={toggleSam2Boxes}
      >
        SAM 2 boxes · {count}
      </Button>
    </Tooltip>
  );
};
